import { gql } from '@apollo/client';

export * from './escrowRequestCertifiedAddon.mutation.generated';

export const ESCROW_REQUEST_CERTIFIED_ADDON = gql`
  mutation escrowRequestCertifiedAddon($escrowId: ID!, $message: String!) {
    escrowRequestCertifiedAddon(input: { escrowId: $escrowId, message: $message }) {
      success
      errors
    }
  }
`;
